import React from 'react';
import classNames from 'classnames';
import { InputTextarea } from 'primereact/inputtextarea';
import { DynamicFormFieldProps } from '../../types/types';
import { getDynamicFieldTooltip } from '../../../utils/helper';
import { isAttributeDisabled } from '../../../utils/attribute';

type Props = DynamicFormFieldProps;

export default function TextAreaInput({
  attribute,
  field,
  fieldState,
}: Props) {
  return (
    <InputTextarea
      {...field}
      id={field.name}
      className={classNames({ 'p-invalid': fieldState.error })}
      disabled={isAttributeDisabled(attribute)}
      {...getDynamicFieldTooltip(attribute)}
    />
  );
}
